import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { isTeamsBrandedExperience } from '@ms/yammer-web-support/dist/teamsBrandedExp';

export const useIsEngageIASimplificationPhase1WithoutReporting = (): boolean => {
  const isEngageIASimplificationPhase1 = useExperimentTreatment('EngageIASimplificationPhase1');

  return !isTeamsBrandedExperience() && isEngageIASimplificationPhase1;
};
